import api from "./axios";

// 📂 트리 조회
export const getBimTree = (projectId) =>
  api.get(`/bim/files/tree/`, { params: { project: projectId } });

// 📂 폴더 생성
export const createBimFolder = (data) =>
  api.post(`/bim/folders/`, data);

// 📂 폴더 삭제
export const deleteBimFolder = (folderId) =>
  api.delete(`/bim/folders/${folderId}/`);

// 📄 파일 업로드 (glTF + BIN 등)
// 기존 로직과 다르게, 'folder' ID도 보낼 수 있음
export const uploadBimFile = (formData) =>
  api.post(`/bim/files/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// 📄 파일 삭제
export const deleteBimFile = (fileId) =>
  api.delete(`/bim/files/${fileId}/`);
